
import React, { createContext, useContext, useEffect, useState, useCallback } from "react"
import { getVoiceiiTagTranslation, voiceiiTranslation } from "../utils"
import { FetchHelper } from "../utils/fetchHelper"

const LocalizationContext = createContext({
    language: "",
    setLanguage: () => {},
    isSessionReady: false,
    setIsSessionReady: () => {},
    voiceiiObjectData: {},
    setVoiceiiObjectData: () => {},
    voiceiiTags: (text) => text,
})

function LocalizationProvider({ children }) {
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem("language") || ""
    })

    const [isSessionReady, setIsSessionReady] = useState(false)
    const [voiceiiObjectData, setVoiceiiObjectData] = useState({})

    /** Fetch user preferred language */
    const fetchUserLanguage = useCallback(async () => {
        try {
            const res = await FetchHelper.get(
                "api/v1/user/details", // url
            )

            if (res?.data?.status) {
                const apiLang = res?.data?.data?.user_details?.language
                setLanguage(apiLang)
                localStorage.setItem("language", apiLang)
            }
        } catch (error) {
            console.warn("Failed to fetch user language", error)
        }
    }, [])

    /** Translation helper */
    const voiceiiTags = useCallback(
        (text, data) => voiceiiTranslation(text, language, voiceiiObjectData, data),
        [language, voiceiiObjectData],
    )
    /** Init after login */
    useEffect(() => {
        if (!localStorage.getItem("language")) {
            setLanguage("en")
        }
        if (isSessionReady) fetchUserLanguage()
        if (!localStorage.getItem("voiceiiObjectData") || isSessionReady) {
            (async () => {
                const tag = await getVoiceiiTagTranslation()
                setVoiceiiObjectData(tag)
            })()
        } else {
            const storedTags = localStorage.getItem("voiceiiObjectData")
            if (storedTags) {
                setVoiceiiObjectData(JSON.parse(storedTags))
            }
        }
    }, [fetchUserLanguage, isSessionReady])

    /** Persist language */
    useEffect(() => {
        if (language) {
            localStorage.setItem("language", language)
        }
    }, [language])

    return (
        <LocalizationContext.Provider
            value={{
                language,
                setLanguage,
                isSessionReady,
                setIsSessionReady,
                voiceiiObjectData,
                voiceiiTags,
                setVoiceiiObjectData,
            }}
        >
            {children}
        </LocalizationContext.Provider>
    )
}

export const useLocalization = () => useContext(LocalizationContext)

export default LocalizationProvider
